import * as React from "react";
import { Fragment } from "react";
import { styled } from "@mui/material/styles";
import {
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Chip,
  Typography,
} from "@mui/material";
import { CgEye } from "react-icons/cg";
import { MdEdit } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { tableCellClasses } from "@mui/material/TableCell";

import pages from "../../../constants/pages";
import { colors } from "../../css components/Style";
import { TextAvatar } from "../../../components";

const Icon = styled(IconButton)`
  border: 1px solid ${colors?.sideBarColor};
  color: ${colors?.sideBarColor};
  height: 35px;
  width: 35px;
  margin: 0 5px;
  padding: 0 5px;
  &:hover {
    border: 1px solid ${colors?.sideBarColor};
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  }
`;

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: colors.iconColor,
    color: "#fff",
    fontSize: "11px",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    backgroundColor: "#F9F9F9",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  ".MuiTableCell-root": {
    border: "none",
    padding: "10px",
    fontSize: "12px",
  },

  "&:nth-of-type(2n+1)": {
    backgroundColor: "rgba(249, 249, 249, 1)",
  },
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export default function List({ campaigns, component, categorize }) {
  const navigate = useNavigate();

  function convertDate(d) {
    let date = new Date(d);

    return (
      date.getDate() + "." + (date.getMonth() + 1) + "." + date.getFullYear()
    );
  }

  function handleRedirection(campaign, mode) {
    if (component === "request") {
      navigate(
        pages.campaignRequestDetails.route +
          campaign.sender_campaignId +
          "?brandID=" +
          campaign.sender_brandId +
          "&mode=" +
          mode
      );
    }

    if (component === "superadmin") {
      navigate(
        pages.superAdminCampaignDetails.route +
          campaign.campaign_id +
          "?brandID=" +
          campaign.brand_id +
          "&mode=" +
          mode,
        { state: { categorize: categorize } }
      );
    }

    if (component === "accepted") {
      navigate(
        pages.campaignAcceptedDetails.route +
          campaign.campaign_id +
          "?brandID=" +
          campaign.brand_id +
          "&mode=" +
          mode
      );
    }

    if (component === "") {
      navigate(
        pages.campaignDetails.route + campaign.campaign_id + "?mode=" + mode
      );
    }
  }

  return (
    <Fragment>
      {component !== "superadmin" && (
        <Typography style={{ opacity: "0.6", padding: "10px 0" }}>
          NOTE: You can only edit campaigns that are not locked.
        </Typography>
      )}
      <TableContainer
        sx={{ maxHeight: "90%", borderRadius: "10px" }}
        component={Paper}
      >
        <Table sx={{ minWidth: 700 }} aria-label="customized table">
          <TableHead style={{ height: "65px" }}>
            <TableRow>
              <StyledTableCell />

              <StyledTableCell>Campaign Name</StyledTableCell>
              <StyledTableCell>Campaign Period</StyledTableCell>
              <StyledTableCell>Conversion</StyledTableCell>
              {/* {component === "superadmin" && (
                <StyledTableCell>User Count</StyledTableCell>
              )} */}
              <StyledTableCell>Status</StyledTableCell>
              <StyledTableCell>Action</StyledTableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {campaigns.map((campaign) => (
              <StyledTableRow style={{ padding: "10px", border: "none" }}>
                <Fragment>
                  <StyledTableCell component="th" scope="row">
                    <TextAvatar
                      size={{
                        height: "30px",
                        width: "30px",
                      }}
                      userName={campaign.campaign_name}
                    />{" "}
                  </StyledTableCell>

                  <StyledTableCell component="th" scope="row">
                    {campaign.campaign_name}
                  </StyledTableCell>

                  <StyledTableCell component="th" scope="row">
                    {!!campaign.start_duration
                      ? convertDate(campaign.start_duration) +
                        " - " +
                        convertDate(campaign.end_duration)
                      : "N.A."}
                  </StyledTableCell>

                  <StyledTableCell component="th" scope="row">
                    {campaign.conversion_type || "N.A."}
                  </StyledTableCell>

                  {/* {component === "superadmin" && (
                    <StyledTableCell component="th" scope="row">
                      {campaign.status === "READY"
                        ? campaign.user_Count
                        : "-" || "N.A"}
                    </StyledTableCell>
                  )} */}

                  <StyledTableCell>
                    <StatusChip campaign={campaign} />
                  </StyledTableCell>

                  <StyledTableCell style={{ display: "flex" }}>
                    {component === "" && campaign.campaignIsEditable ? (
                      <Tooltip title="Edit Campaign">
                        <Icon
                          onClick={() => handleRedirection(campaign, "edit")}
                        >
                          <MdEdit style={{ height: "20px", width: "20px" }} />
                        </Icon>
                      </Tooltip>
                    ) : (
                      <div style={{ width: "44px" }} />
                    )}

                    <Tooltip title="View Campaign">
                      <Icon>
                        <CgEye
                          onClick={() => handleRedirection(campaign, "view")}
                          style={{ height: "20px", width: "20px" }}
                        />
                      </Icon>
                    </Tooltip>
                  </StyledTableCell>
                </Fragment>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Fragment>
  );

  function StatusChip({ campaign }) {
    let color;
    if (
      campaign.campaign_status === "REQUESTED" ||
      campaign.campaign_status === "CREATED"
    ) {
      color = colors.yellow;
    }

    if (
      campaign.campaign_status === "OFFER_ACCEPTED" ||
      campaign.campaign_status === "ACTIVE" ||
      campaign.campaign_status === "ACCEPTED" ||
      campaign.campaign_status === "PARTIAL_ACCEPTED"
    ) {
      color = colors.green;
    }

    if (campaign.campaign_status === "INITIATED") {
      color = colors.initiated;
    }

    if (
      campaign.campaign_status === "REJECTED" ||
      campaign.campaign_status === "FAILED" ||
      campaign.campaign_status === "PARTIAL_REJECTED" ||
      campaign.campaign_status === "OFFER_REJECTED" ||
      campaign.campaign_status === "INTERRUPTED"
    ) {
      color = colors.error;
    }

    if (campaign.campaign_status === "Expired") {
      color = "#bdbdbd";
    }

    if (campaign.campaign_status === "READY") {
      color = colors.success;
    }

    if (campaign.campaign_status === "COMPLETED") {
      color = "#2f8632";
    }

    return (
      <Chip
        style={{
          position: "relative",
          left: "-13px",
          fontSize: "12px",
          backgroundColor: color,
          color: "#fff",
        }}
        label={campaign.campaign_status.replace(/_/g, " ").toUpperCase()}
      />
    );
  }
}
